import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../common/models/Page";
import { DashboardState } from "../models/DashboardState";

const setPageActiveSrvices = (state: DashboardState, action: PayloadAction<Page>) => {
    state.activeSrvicePage.page = action.payload.page;
}

export default setPageActiveSrvices;